export const CreaterInfo = () => {
  return (
    <div className="creater-info__content">
      <p className="creater-info__text">Created by Pavlo Maistrenko,<br /> 2025.</p>
    </div>
  );
}
